import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=678cc208&scoped=true"
import script from "./UnitList.vue?vue&type=script&lang=ts"
export * from "./UnitList.vue?vue&type=script&lang=ts"
import style0 from "./UnitList.vue?vue&type=style&index=0&id=678cc208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678cc208",
  null
  
)

export default component.exports